/**
 * Created by yezh on 2018/2/24.
 * 全局变量
 */

import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      userName: '游客',
      userId: ''
    },
    token: null,
    title: '',
    toast: '',
    headColor: '',
    pictures: {}
  },
  getters: {
    showMsg: state => {
      return state.toast
    },
    getPictures: state => {
      return state.pictures
    }
  },
  mutations: {
    setToastMsg: (state, msg) => {
      state.toast = msg
    },
    setHeadColor: (state, msg) => {
      state.headColor = msg
    },
    setPictures: (state, pictures) => {
      state.pictures = pictures
    },
    [types.LOGIN]: (state, data) => {
      console.log('执行了介个2')
      localStorage.token = data.accesstoken
      localStorage.user = JSON.stringify(data)
      state.token = data.accesstoken
      state.user = data
    },
    [types.RESTORE]: (state, data) => {
      console.log('执行了介个1')
      let user = JSON.parse(data)
      localStorage.token = user.accesstoken
      localStorage.user = data
      state.token = user.accesstoken
      state.user = user
    },
    [types.LOGOUT]: (state) => {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      state.token = null
    },
    [types.TITLE]: (state, data) => {
      state.title = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/common/js/store.js